import {getDefaultPageForRole} from "~/utils/roles";
import {usePermissionsStore} from "~/stores/permissions";

export default defineNuxtRouteMiddleware((to, from) => {
    const {currentRoutePath, user} = useAuth()
    currentRoutePath.value = to.path

    // Якщо підрозділ заблокований, дозволяємо тільки дефолтну сторінку для ролі
    if (user.value?.divisionBlocked) {
        const defaultPage = getDefaultPageForRole(user.value?.role)
        if (to.path !== defaultPage) {
            return navigateTo(defaultPage)
        }
    }
})